import type { WorldView } from './types';
import { claims, principal } from './model';

/** Never carry the previous wallet's figures into a freshly switched account. */
export function accountOverview(view: WorldView) {
  const address = view.user.connected ? view.user.address?.toLowerCase() : null;
  const account = address && view.account?.account.toLowerCase() === address ? view.account : null;
  const runners = address && view.runners?.account.toLowerCase() === address ? view.runners : null;
  const owned = runners?.owned.filter((r) => r.status === 'live' && r.owner?.toLowerCase() === address) ?? [];
  return { account, owned, collectionReady: !!runners, principal: principal(account), claims: claims(account) };
}
